import {sortBy} from "lodash/collection";
import {API_URL} from "@/config/apiurl.config";


export default class RagService {
     generateSourceCards(sources){
         if(sources.length > 0) {
            sources = sources.map(source=>{
                let url='';
                if (['jpg', 'jpeg', 'png', 'bmp', 'tiff', 'tif', 'gif', 'webp'].includes(source.file_type)) {
                    url=API_URL.ragUrl() +`documents/${source.document_id}/download`
                }
                else{
                    if(source.file_type !== 'pdf'){
                        url=API_URL.ragUrl()+ `documents/${source.document_id}/view-as-pdf`
                    }
                    else{
                        url=API_URL.ragUrl()+`documents/${source.document_id}/pdf`
                    }
                }
                const link = `<a target="_blank" class="btn btn-xs btn-primary" style="font-size: 9px !important;" href="${url}">View File</a>`
                return `
                <div class="row mb-2 justify-content-center">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body p-1">
                                <div class="d-flex justify-content-between align-items-center" title="${source.title}">
                                    <div class="p-1 w-75 text-truncate" style="text-overflow: ellipsis">
                                        <strong>${source.title}</strong>
                                    </div>
                                    <div class="badge badge-success p-1">
                                       ${Math.round(source.similarity_score * 100)} %
                                    </div>
                                </div>
                                <div class="p-1">
                                    <blockquote title="${source.content}" style="display: -webkit-box;-webkit-line-clamp: 2; -webkit-box-orient: vertical;overflow: hidden;">
                                        <small>${source.content}</small>
                                    </blockquote>
                                </div>
                                 <div>
                                  ${link}
                                 </div>
                            </div>
                        </div>
                    </div>
                </div>
                `
            }).join('')
            return sources
         }
         return ''

    }
     generateAiResponse(html,sources){
         const cards=this.generateSourceCards(sources)
         const cardDiv = `<div class="mt-2">
                            <div class="mb-2">
                              <strong>SOURCES:</strong>
                            </div>
                            ${cards}
                        </div>`
         if(html === null) {
             return cardDiv
         }
         return html + cardDiv
     }
    async fetchRagResponse(text,type) {
        let params= {
            query:text,
            similarity_threshold:0.3
        }

        const url = type === 'ai' ? 'https://elitesdsi.com/search/rag' : 'https://elitesdsi.com/search/search'

        params = type ==='ai' ? {...params,model:'qwen2.5:7b',max_results:5} : {...params,n_results:10}

        const result = await fetch(url,{
            method:"POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body:JSON.stringify(params)
        })

        if(result.ok){
            return result.json();
        }
    }
}